





























































































import { Component, Vue } from 'vue-property-decorator';
import { AppUserDayViewModel, TeamOverviewApprovalModel } from '@/services/api/nswag/stapiclient_generated';
import { stTimeEntryDayApprovalApi } from '@/services/st-api';
import { DateTime } from 'luxon';
import TeamOverviewApprovalEdit from '@/views/TeamOverview/TeamOverviewApprovalDay.vue';
import TeamOverviewApprovalDay from '@/views/TeamOverview/TeamOverviewApprovalDay.vue';
import {
  DailyWorkTimeWarningEnums,
  FreeDayWarningEnums,
  GetTeamOverviewApprovalIcon,
  PauseWarningEnums,
  TimeEntryWarningEnums,
} from '@/views/TeamOverview/team-overview-approval-icon';
import { ApprovalStore } from "@/store/approval-store";

@Component({ components: { TeamOverviewApprovalDay, TeamOverviewApprovalEdit } })
export default class TeamOverviewApproval extends Vue {
  loading = true;
  delayLoading = false;

  get model(){
    return ApprovalStore.model;
  }

  get date(){
    return ApprovalStore.date;
  }

  set date(data: DateTime){
    ApprovalStore.setDate(data);
  }

  get dateTo(): DateTime {
    return this.date.plus({ days: 4 * 7 });
  }

  hasViolatedValidations(day: AppUserDayViewModel) {
    return day.hasViolatedValidationRules;
  }

  getPauseWarnings(day: AppUserDayViewModel): string | null {
    return GetTeamOverviewApprovalIcon(day, PauseWarningEnums);
  }

  getFreeDayWarnings(day: AppUserDayViewModel): string | null {
    return GetTeamOverviewApprovalIcon(day, FreeDayWarningEnums);
  }

  getDailyWorkTimeWarnings(day: AppUserDayViewModel): string | null {
    return GetTeamOverviewApprovalIcon(day, DailyWorkTimeWarningEnums);
  }

  getTimeEntryWarnings(day: AppUserDayViewModel): string | null {
    return GetTeamOverviewApprovalIcon(day, TimeEntryWarningEnums);
  }

  async changeWeek(plusminus: number) {
    this.date = this.date.plus({ days: plusminus * 7 });
    await this.loadData();
  }

  async approvalStateChanged() {
    await this.loadData(); //TOOD: für einzelnen Nutzer
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    try {
      this.loading = true;
      await ApprovalStore.getModel()
    } finally {
      this.loading = false;
    }
  }
}
